import type { IPackChatMessage } from "./types";

export const packChatAuthorName = (
  message: IPackChatMessage,
  short = false,
) => {
  if (message.author_type === "ai") return "Volca AI";
  const name = message.author?.name ?? "PackChat";
  return short ? name.split(" ")[0] : name;
};
